// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HMKz","question":"styles_question__1lPlu","inputVisibleButton":"styles_inputVisibleButton__177_U","note":"styles_note__3jEi1"};